import { getFacebookClientId, appleClientId, getAppleredirectUri } from "../../utils/general-config";
import FacebookLogin from "react-facebook-login";
import AppleSignin from "react-apple-signin-auth";
import { useTranslation } from "react-i18next";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import GoogleCaptcha from "../sign-up/captcha";
const LegalSimpliSignIn = ({
  pwdNavigate,
  signUpNavigate,
  onSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  passwordError,
  emailError,
  passwordErrorMsg,
  onEmailChangeHandler,
  emailId,
  onPwdChangeHandler,
  onPasswordKeyPress,
  pwd,
  appleLogin,
  loginError,
  loginErrorMessage,
  showCaptcha,
  onCaptchaSuccess,
  recaptchaRef,
}) => {
  const { t } = useTranslation();
  let redirctUri = getAppleredirectUri();

  return (
    <>
      <Helmet>
        <meta name="description" content={t("sign_in.ls.description_meta")} />
        <title>{t("page_title.ss.sign_in")}</title>
      </Helmet>
      <section className="main-content ">
        <div className="container mx-auto ">
          <div className="form-wrap border border-[#FF6600] rounded-[10px]  !p-4 md:!p-10 gap-5 shadow-[4px_4px_10px_0px_#0000000D]">
            <hgroup className="text-center user-page">
              <h1
                className="main-headline  text-[#424a5b] !font-rethink text-4xl font-bold mt-0 pb-2.5"
                style={{ fontFamily: '"Rubik", sans-serif' }}
              >
                {t("sign_up.ls.member_login")}
              </h1>
            </hgroup>

            {/* <div className="social-login ">
              <div className="social-login--google">
                <button type="button" id="googleBtn" className="google-login-button text-white" onClick={googleLogin}>
                  <div className="bg-white m-px rounded-sm">
                    <img src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"} />
                  </div>
                  <span> {t("sign_in.signin_with_google")}</span>
                </button>
              </div>
              <div className="social-login--facebook">
                <FacebookLogin
                  appId={getFacebookClientId()}
                  fields="name,email"
                  textButton={t("sign_in.signin_with_fb")}
                  callback={responseFacebook}
                  icon={
                    <img
                      src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                      className="facebook-login-button"
                      id="fbBtn"
                    />
                  }
                />
              </div>
            </div> */}

            {/*  this part is commented because we don't have Apple key for LegalSimpli now, so 
            using old social media login. Once we will get the key , this commented part will be used for social media login (according to new figma)*/}

            <div className="social-login  justify-between flex-col w-full">
              <div className="flex items-center">
                <div className="social-login--google w-full mb-0">
                  <button
                    type="button"
                    className="google-login-button text-xs lg:text-sm text-white !bg-[#4181EF] mt-[1px] w-auto !flex items-center justify-center h-[41px] rounded-[5px]"
                    onClick={googleLogin}
                    id="googleBtn"
                  >
                    <div className="bg-white ml-[2px] rounded-l-md rtl:hidden">
                      <img
                        src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                        height="20px"
                        width="20px"
                      />
                    </div>
                    <span className="text-sm lg:text-base rtl:ml-0 ml-10 !font-rethink">
                      {t("sign_in.signin_with_google")}  </span>{" "}
                    <div className="bg-white ml-[2px] rounded-r-md !right-0 !left-auto mr-[1px] ltr:hidden">
                      <img
                        src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"}
                        height="20px"
                        width="20px"
                      />
                    </div>
                  </button>
                </div>
                <div className="social-login--facebook !leading-none mb-0 rtl:mr-1 ">
                  <FacebookLogin
                    appId={getFacebookClientId()}
                    autoLoad={false}
                    fields="name,email"
                    textButton=""
                    callback={responseFacebook}
                    cssClass=""
                    size="!w-[41px] !h-[40px] "
                    icon={
                      <img
                        src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                        className="facebook-login-button border border-[#EAEBED] !w-[41px] !h-[40px]  !relative !rounded-[5px]"
                        id="fbBtn"
                      />
                    }
                  />
                </div>
              </div>
              {/* 
                                <div className="social-login--apple w-full">
                                  <AppleSignin
                                    className="apple-signin-button"
                                    authOptions={{
                                      clientId: appleClientId(),
                                      scope: "email name",
                                      redirectURI: redirctUri + "signin-apple",
                                      usePopup: true,
                                    }}
                                    onSuccess={appleLogin}
                                    onError={(error) => {
                                      console.error("Apple login failed:", error);
                                      appleLogin({
                                        user: null,
                                        authorization: {
                                          id_token: null,
                                          error: error.message,
                                        },
                                      });
                                    }}
                                    uiType="light"
                                    buttonExtraChildren={null}
                                    style={{ display: "none" }}
                                  />
                                  <button
                                    // onClick={() => document.querySelector(".apple-signin-button").click()}
                                    className="relative flex items-center justify-center px-2.5 py-2 border border-[#EAEBED] bg-white cursor-pointer rounded-md w-full -mt-[6px]"
                                  >
                                    <img
                                      src={process.env.PUBLIC_URL + "/static/images/apple-icon.svg"}
                                      alt="Apple"
                                      className="absolute left-3 w-5 h-6"
                                    />
                                    <span className="text-center w-full ml-5">{t("sign_in.signin_with_apple")}</span>
                                  </button>
                                </div> */}
            </div>

            <div
              className="max-w-[220px] flex items-center w-full relative gap-5 mx-auto my-6"
              role="separator"
              aria-label="Email sign up divider"
            >
              <div className="flex-1 h-px bg-gradient-to-r from-white to-[#687585]" />
              <div className="text-[18px] text-[#687585] font-rethink">or</div>
              <div className="flex-1 h-px bg-gradient-to-r from-[#687585] to-white" />
            </div>
            <div className="form-container !max-w-96">
              {/* <div className="form-text mb-2">
                {(passwordError || emailError) && (
                  <p
                    key="pswrdErr"
                    className="alert error border bg-orange-50 border-orange-500 text-[#fe8c26] px-2 py-1"
                    dangerouslySetInnerHTML={{
                      __html: passwordErrorMsg,
                    }}
                  />
                )}
              </div>  */}
              <div className="form-text mb-2">
                {(passwordError || emailError) && (
                  <p
                    key="pswrdErr"
                    className="text-red-600 text-center w-full "
                    dangerouslySetInnerHTML={{
                      __html: passwordErrorMsg,
                    }}
                  />
                )}
                {loginError && <p className="text-center text-red-500">{loginErrorMessage}</p>}
              </div>

              <div className="">
                <InputText
                  showLabel={false}
                  id="email"
                  text="Email Address"
                  onChange={onEmailChangeHandler}
                  className="border-gray-300 rounded  p-2 border mb-3 !font-rethink"
                  value={emailId.trim()}
                  maxLength={100}
                  placeholder={t("sign_in.ls.placeholder_email")}
                />
              </div>
              <div className="">
                <InputText
                  showLabel={false}
                  id="password"
                  text="Password"
                  type="password"
                  onChange={onPwdChangeHandler}
                  value={pwd}
                  className="border-gray-300 rounded  p-2 border mb-3 !font-rethink"
                  onKeyPress={onPasswordKeyPress}
                  placeholder={t("sign_in.ls.placeholder_password")}
                />
              </div>
              <div className="flex flex-col items-center space-y-4">
                <div className="check_box flex justify-between items-center w-full px-1 ">
                  <label className="form-check flex items-center space-x-2 text-sm text-[#16283D]">
                    <input className="form-check-input" type="checkbox" value="" />
                    <span className="checkmark peer-checked:bg-orange-500 !font-rethink">
                      {t("sign_in.ls.remember_me")}
                    </span>
                  </label>
                  <button
                    id="ForgotPassword"
                    className="setCulture text-sm text-[#0E76FF] font-normal underline"
                    isLoading={false}
                    disabled={disableBtn}
                    onClick={pwdNavigate}
                  >
                    {t("sign_in.ls.forgot")}
                  </button>
                </div>

                  {showCaptcha && (
                    <div className="flex flex-row justify-center mt-2" style={{ width: "304px" }}>
                      <GoogleCaptcha onCaptchaSuccess={onCaptchaSuccess} recaptchaRef={recaptchaRef} />
                    </div>
                  )}
                <div className="md:relative bottom-0 left-0 bg-white border-gray-300 p-0 md:pt-[5px] text-center w-full z-50">
                  <button
                    className="rounded-full bg-[#16283D] items-center justify-center py-3 md:py-3 px-20 md:px-[9.5rem] text-center text-lg font-bold text-white font-rethink uppercase"
                    isLoading={false}
                    disabled={false}
                    type="submit"
                    id="signInButton"
                    onClick={onSignIn}
                  >
                    {t("sign_in.btn_cta")}
                  </button>
                </div>

                <p className="!mt-8">
                  <span class="font-normal text-sm text-[#16283D]">{t("sign_in.ls.don't _have_account")} </span>
                  <button
                    className="setCulture font-normal text-sm text-[#0E76FF]"
                    isLoading={false}
                    disabled={disableBtn}
                    onClick={signUpNavigate}
                  >
                    <i>
                      <FontAwesomeIcon icon={faUser} className="text-center" />
                    </i>{" "}
                    {t("sign_in.ls.sign_up")}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LegalSimpliSignIn;
